import React from 'react';
import PropTypes from 'prop-types';

import {
  FieldValue
} from '../../../packages/detail-panel';

import {
  ResourceCard,
  ResourceRef,
} from '../../resource';

import { 
  fmtIso8601AsLocalDateTime,
  fmtListAsCsv,
} from '../../utils/formatters';

export default function CredentialCard(props) {

  const { resource } = props;

  if(!resource) return(null); 

  const fields=[
    { section: "Details", fields: [
      { name: "ResourceId", label: "ID", component: FieldValue, options: { maxLength: 40 } }, 
      { name: "ClientAccountId", label: "Client", component: ResourceRef, options: { type: 'Client' } },
      { name: "StackCreated", label: "Created", formatter: fmtIso8601AsLocalDateTime },
      { name: "StackUpdated", label: "Updated", formatter: fmtIso8601AsLocalDateTime },
    ]},
    { section: "Security", fields: [
      { name: "SecurityConfiguration.Rotation", label: "Token Rotation" },
      { name: "SecurityConfiguration.SourceIPWhitelist", label: "IP Whitelist", formatter: fmtListAsCsv },
    ]},
    { section: "Landing Zone", fields: [
      { name: "TargetResourceSpec", label: "Target" },
      { name: "TargetResource.LandingZoneTarget.LandingZoneId", label: "Resource Id" },
      { name: "TargetResource.LandingZoneTarget.S3SecurityConfiguration.AllowListObjects", label: "Allow List Objects" },
    ]},
  ];

  return (
    <ResourceCard 
      resource={resource} 
      fields={fields} 
      stack 
      dashboard 
    />
  );
}

CredentialCard.propTypes = {
  resource: PropTypes.object.isRequired,
};

CredentialCard.defaultProps = {
};
